import { Injectable } from '@angular/core';

import { db } from '@app/offline-tools/dexie-db/app-storage-db';

import { SharedUtilsService } from './shared-utils.service';

@Injectable({
  providedIn: 'root'
})
export class UserOfflineStorageService {

  constructor(
    private _sharedUtilsService: SharedUtilsService
  ) { }


  async clearTableInOfflineStorage(_key: string): Promise<void> {
    if (!_key) return;

    if (!db) {
      console.warn('Dexie DB not initialized — skipping clear.');
      return;
    }

    try {
      const table = db.tables.find(t => t.name === _key);
      if (table) {
        await table.clear();
      } else {
        console.log(`Passed key "${_key}" does not match any IndexedDB table.`);
      }
    } catch (_err) {
      console.error(`Error clearing Dexie table for key "${_key}":`, _err?.message || _err);
    }
  }


  async clearOfflineStorage(_tablesToKeep: string[] = []): Promise<void> {
    if (!db) {
      console.warn('Dexie DB not initialized — skipping clear.');
      return;
    }

    try {
      await Promise.all(
        db.tables.filter(_table => !_tablesToKeep.includes(_table.name)).map(_table => _table.clear())
      );
    } catch (_err) {
      console.error('Error clearing Dexie tables: ', _err?.message || _err);
    }
  }


  resetOfflineStorage(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        if (db) {
          const tablesToKeep: string[] = ['userAccessControls'];
          await this.clearOfflineStorage(tablesToKeep);
          this._sharedUtilsService.showNotification("Offline data has been reset.");
        } else {
          console.log('Dexie DB not initialized — skipping clear.');
        }

        resolve(null);
      } catch (_err) {
        console.log('Error in UserOfflineStorageService resetOfflineStorage: ', _err?.message || _err);
        resolve(null);
      }
    });
  }


  cleanupExpiredRecords(_tableName: string): Promise<boolean> {
    return new Promise(async (resolve) => {
      if (!db) return resolve(false);

      let recordsExpired = false;

      try {
        const table = db.table(_tableName) ?? null;
        if (table != undefined) {
          const now = Date.now();
          const expiredRecords = await table.where('expiresAt').belowOrEqual(now).toArray();
          const primaryKeysToDelete = expiredRecords.map(record => record?._id);
          if (primaryKeysToDelete.length > 0) {
            await table.bulkDelete(primaryKeysToDelete);
            recordsExpired = true;
          }
        } else {
          console.log(`No table was found in dexie for ${_tableName}.`);
        }
      } catch (err) {
        console.log(`Error cleaning up ${_tableName}:`, err);
      }

      resolve(recordsExpired);
    });
  }
}